import React from 'react'

const Rough = () => {
  return (
    <>
      <h1>Rough </h1>
      <h1>Rough </h1>
      <h1>Rough </h1>
      <h1>Rough </h1>
      <h1>Rough </h1>
      <h1>Rough </h1>
      <h1>Rough </h1>
      <h1>Rough </h1>
      <h1>Rough </h1>
    </>
  )
}

export default Rough
